module.exports = __webpack_public_path__ + "static/media/BipolarActive.010d2be2.svg";